<template>
    <div class="binary">
        <v-style>
            .answer_1 { background-image: url({{ img1_off }}); } .answer_1:hover
            { background-image: url({{ img1_on }}); } .answer_2 {
            background-image: url({{ img2_off }}); } .answer_2:hover {
            background-image: url({{ img2_on }}); }
        </v-style>

        <b-row align-h="center">
            <b-col md="3" sm="1">
                <div class="answer answer_1"></div>
            </b-col>
            <b-col md="3" sm="1">
                <div class="answer answer_2"></div>
            </b-col>
        </b-row>
        <!-- <img :src="require(`@imgSrc/binaire/${type}/${type}vert_on.gif`)" /> -->
        <!-- <img :src="require(`@/assets/binaire/${type}/${type}rouge_off.gif`)" /> -->
    </div>
</template>

<script>
export default {
    name: 'Binary',
    props: ['type'],
    computed: {
        img1_off: function () {
            return require(`@/assets/binaire/${this.type}/${this.type}rouge_off.gif`);
        },
        img1_on: function () {
            return require(`@/assets/binaire/${this.type}/${this.type}rouge_on.gif`);
        },
        img2_off: function () {
            return require(`@/assets/binaire/${this.type}/${this.type}vert_off.gif`);
        },
        img2_on: function () {
            return require(`@/assets/binaire/${this.type}/${this.type}vert_on.gif`);
        },
    },
    components: {
        'v-style': {
            render: function (createElement) {
                return createElement('style', this.$slots.default);
            },
        },
    },
    data() {
        return {
            img1: null,
            // img1: require('@/assets/binaire/yaourt/yaourtvert_off.gif'),
        };
    },

    methods: {},
};
</script>

<style  lang="scss">
.binary {
    @include media-breakpoint-down(sm) {
        .col-sm-1 {
            width: auto;
        }
    }
    .answer {
        transition: all 0.1s ease-out;
        width: 170px;
        height: 170px;
        margin-left: auto;
        margin-right: auto;
        @include media-breakpoint-down(sm) {
            background-size: 30vw;
            width: 34vw;
            height: 34vw;
        }
    }
    .answer:hover {
        cursor: pointer;
    }
}
</style>
